/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  AlertsBannersDefinitionsResponse,
  MarketingBanner,
  MarketingBannerHistoryResponse,
  UpdateMarketingBannerRequest,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get all alerts and banners definitions.
 */
export const getAlertBannersDefinitions = (
  options?: SecondParameter<
    typeof backofficeRequest<AlertsBannersDefinitionsResponse>
  >,
) => {
  return backofficeRequest<AlertsBannersDefinitionsResponse>(
    { url: `/api/v1/alerts-banners`, method: "GET" },
    options,
  )
}
/**
 * @summary Update a marketing banner row. A field left out is unchanged; buttonText and buttonLink both empty clear the button.
 */
export const updateMarketingBanner = (
  id: number,
  updateMarketingBannerRequest: UpdateMarketingBannerRequest,
  options?: SecondParameter<typeof backofficeRequest<MarketingBanner>>,
) => {
  return backofficeRequest<MarketingBanner>(
    {
      url: `/api/v1/alerts-banners/banners/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateMarketingBannerRequest,
    },
    options,
  )
}
/**
 * @summary Every saved version of a marketing banner row, newest first. The oldest is the row's state before Nova editing began.
 */
export const getMarketingBannerHistory = (
  id: number,
  options?: SecondParameter<
    typeof backofficeRequest<MarketingBannerHistoryResponse>
  >,
) => {
  return backofficeRequest<MarketingBannerHistoryResponse>(
    { url: `/api/v1/alerts-banners/banners/${id}/history`, method: "GET" },
    options,
  )
}
export type GetAlertBannersDefinitionsResult = NonNullable<
  Awaited<ReturnType<typeof getAlertBannersDefinitions>>
>
export type UpdateMarketingBannerResult = NonNullable<
  Awaited<ReturnType<typeof updateMarketingBanner>>
>
export type GetMarketingBannerHistoryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBannerHistory>>
>
